<div class="inner-block">
  <button
    class="tabbable no-outline"
    (click)="setTab(DashboardTab.details)"
    [ngClass]="{active : activeTab === DashboardTab.details}"
  >
    Detaljer
  </button>
  <button
    class="tabbable no-outline"
    (click)="setTab(DashboardTab.stats)"
    [ngClass]="{active : activeTab === DashboardTab.stats, disabled: !isFollowup}"
    [disabled]="!isFollowup"
  >
    Statistik
  </button>
  <button
    class="tabbable no-outline text-capitalize"
    (click)="setTab(DashboardTab.creatives)"
    [ngClass]="{active : activeTab === DashboardTab.creatives}"
  >
    Material
  </button>
  @if(maySeeInventory) {
  <button
    class="tabbable no-outline"
    (click)="setTab(DashboardTab.inventory)"
    [disabled]="campaign?.status === 'unbooked'"
    [ngClass]="{active : activeTab === DashboardTab.inventory}"
    >
      Lager
    </button>
  }
  @if(maySeeOmsInventory) {
    <button
      class="tabbable no-outline"
      (click)="setTab(DashboardTab.omsInventory)"
      [disabled]="campaign?.status === 'unbooked'"
      [ngClass]="{active : activeTab === DashboardTab.omsInventory}"
    >
      OMS
    </button>
  }
  @if(maySeeInvoices) {
    <button
      class="tabbable no-outline"
      (click)="setTab(DashboardTab.invoices)"
      [disabled]="campaign?.status === 'unbooked'"
      [ngClass]="{active : activeTab === DashboardTab.invoices}"
    >
      Fakturor
    </button>
  }
  @if(maySeeGoals && campaign?.status !== 'unbooked') {
    <button
      class="tabbable no-outline"
      (click)="setTab(DashboardTab.goals)"
      [ngClass]="{active : activeTab === DashboardTab.goals}"
      [disabled]="!campaignHasGoals"
    >
      Mål
    </button>
  }
  @if(maySeeHistory) {
    <button
      class="tabbable no-outline"
      (click)="setTab(DashboardTab.history)"
      [ngClass]="{active : activeTab === DashboardTab.history}"
    >
      Historik
    </button>
  }
  @if(maySeeAdmin) {
    <button
      class="tabbable no-outline"
      (click)="setTab(DashboardTab.admin)"
      [disabled]="campaign?.ttv_campaign"
      [ngClass]="{active : activeTab === DashboardTab.admin}"
    >
      Admin
    </button>
  }
  @if(activeTab === DashboardTab.details) {
    <dashboard-details [campaign]="campaign"></dashboard-details>
  }
  @if(activeTab === DashboardTab.stats) {
    <outcome></outcome>
  }
  @if(activeTab === DashboardTab.creatives) {
    <creatives-details></creatives-details>
  }
  @if(activeTab === DashboardTab.inventory && maySeeInventory) {
    <campaign-inventory [campaign]="campaign"></campaign-inventory>
  }
  @if(activeTab === DashboardTab.omsInventory && maySeeOmsInventory && campaign) {
    <oms-bookable-checks [campaign]="campaign"></oms-bookable-checks>
  }
  @if(activeTab === DashboardTab.invoices) {
    <invoices
      [campaign]="campaign"
    >
    </invoices>
  }
  @if(activeTab === DashboardTab.goals && maySeeGoals) {
    <campaign-goals></campaign-goals>
  }
  @if(activeTab === DashboardTab.history && maySeeHistory) {
    <campaign-history [campaign]="campaign"></campaign-history>
  }
  @if(activeTab === DashboardTab.admin && maySeeAdmin) {
    <admin-follow-up [campaign]="campaign"></admin-follow-up>
  }
</div>
